const searchFieldOptions = [
  {label:'Enterprise',value: 'Enterprise1'},
  {label:'ContactName',value: 'ContactName'},
  {label:'ContactNo',value: 'ContactNo'},
  {label:'EMail',value: 'Email'},
  {label:'LoginName',value: 'LoginName'}
]

const searchFieldOperation = {
  'Enterprise1': 'Contains',
  'ContactName': 'Contains',
  'ContactNo': 'Contains',
  'EMail': 'Contains',
  'LoginName': 'Contains'
}

export {searchFieldOptions,searchFieldOperation}



// WEBPACK FOOTER //
// ./src/views/company/options.js